import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { SubmitHandler, useForm } from 'react-hook-form'
import { LoginInput } from '../../shared/models/others/login-input'
import ButtonLoading from '../../components/button/ButtonLoading'
import { useLoginMutation } from '../../store/kopiliot-api/auth'

interface LoginFormProps {}

const LoginForm = () => {
  const [mutation, { isLoading }] = useLoginMutation()
  // Init Form
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<LoginInput>()
  const onSubmit: SubmitHandler<LoginInput> = async (data) => {
    try {
      await mutation(data).unwrap()
    } catch (e) {}
  }
  // END TOTO
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Form.Group className="mb-3">
        <Form.Label>Login</Form.Label>
        <Form.Control
          placeholder={'Email address'}
          {...register('username')}
          type="email"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Mot de passe</Form.Label>
        <Form.Control
          placeholder={'Password'}
          {...register('password')}
          type="password"
        />
      </Form.Group>
      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input type="checkbox" {...register('rememberMe')} />
            <Form.Check.Label className="mb-0 text-700">
              Se souvenir de moi
            </Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Link className="fs--1 mb-0" to={'/auth/forgot-password'}>
            Mot de passe oublié ?
          </Link>
        </Col>
      </Row>
      <Form.Group>
        <ButtonLoading
          type="submit"
          className="mt-3 w-100"
          variant="outline-primary"
          text={'Connexion'}
          isLoading={isLoading}
          disabled={isLoading}
        />
      </Form.Group>
    </Form>
  )
}

export default LoginForm
